import React from 'react';
import { Navigate } from 'react-router';
import { LoadingState } from '@eptai/eptai-app-components';
import { useAppAuth } from '../../contexts';

const CUSTOMER_ADMIN_ROLES = ['Admin', 'EptAdmin'];

type AdminRoleGuardProps = {
  children: React.ReactNode;
  redirectTo?: string;
  fallback?: React.ReactNode;
};

export default function AdminRoleGuard({
  children,
  redirectTo = '/',
  fallback = null,
}: AdminRoleGuardProps): React.JSX.Element | null {
  const { user, isLoading } = useAppAuth();
  const roles = (user as { ept_roles?: string[] } | null)?.ept_roles ?? [];
  const isAdmin = roles.some(role => CUSTOMER_ADMIN_ROLES.includes(role));

  if (isLoading) {
    return <LoadingState variant="spinner" text="Loading access..." />;
  }

  if (!isAdmin) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
